/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */

import React from 'react';
import Icon from '@atlaskit/icon';
import type { CustomGlyphProps, IconProps } from '@atlaskit/icon/types';

const JSMMajorIncidentIcon = (props: CustomGlyphProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-testid={props['data-testid']}
	>
		<path
			d="M10.4346 11.7889L10.5206 11.8492L14.6873 15.1826C15.0467 15.4701 15.1049 15.9945 14.8174 16.3539C14.552 16.6856 14.0848 16.7608 13.7318 16.5442L13.6461 16.484L10 13.5666L6.35394 16.484C6.0222 16.7494 5.54985 16.7202 5.25301 16.4314L5.18264 16.3539C4.91725 16.0221 4.94648 15.5498 5.23522 15.2529L5.31278 15.1826L9.47945 11.8492C9.75613 11.6279 10.1387 11.6078 10.4346 11.7889Z"
			fill="#5E6C84"
		/>
		<path
			d="M10.4346 7.62224L10.5206 7.68261L14.6873 11.0159C15.0467 11.3035 15.1049 11.8279 14.8174 12.1872C14.552 12.519 14.0848 12.5942 13.7318 12.3776L13.6461 12.3174L10 9.4L6.35394 12.3174C6.0222 12.5828 5.54985 12.5535 5.25301 12.2648L5.18264 12.1872C4.91725 11.8555 4.94648 11.3832 5.23522 11.0863L5.31278 11.0159L9.47945 7.68261C9.75613 7.46126 10.1387 7.44114 10.4346 7.62224Z"
			fill="#5E6C84"
		/>
		<path
			d="M10.4346 3.45562L10.5206 3.51598L14.6873 6.84932C15.0467 7.13682 15.1049 7.66123 14.8174 8.02062C14.552 8.35236 14.0848 8.42753 13.7318 8.211L13.6461 8.15076L10 5.23337L6.35394 8.15076C6.0222 8.41616 5.54985 8.38692 5.25301 8.09819L5.18264 8.02062C4.91725 7.68888 4.94648 7.21653 5.23522 6.91969L5.31278 6.84932L9.47945 3.51598C9.75613 3.29464 10.1387 3.27452 10.4346 3.45562Z"
			fill="#5E6C84"
		/>
	</svg>
);

const JSMMajorIncident = (props: IconProps) => <Icon {...props} glyph={JSMMajorIncidentIcon} />;

export default JSMMajorIncident;
